<template>
    <div>
        <form class="card card-sm" id="main-form" action="" method="post">
            <div class="card-body row no-gutters align-items-center search_form">
                <div class="col">
                    <slot></slot>
                    <div id="div_id_url" class="form-group">
                        <div class="">
                            <input
                                @keydown="enterClick"
                                v-model="input"
                                @change="change"
                                @input="onInput"
                                type="text"
                                name="url"
                                :placeholder="inputPlaceholder"
                                autofocus="true"
                                class="textinput textInput form-control"
                                required
                                id="id_url">
                        </div>
                    </div>
                </div>
                <div class="col-auto">
                    <button
                        class="btn btn-lg btn-danger"
                        type="submit"
                        id="search"
                        @click.prevent="submit"
                    >
                        <span class="d-none d-md-inline">{{ startButton }}</span>
                        <i class="fas fa-arrow-right"></i>
                    </button>
                </div>
            </div>

        </form>
        <div v-if="linkError" role="alert" class="link-error-msg">{{ linkErrorText }}</div>
    </div>

</template>

<script>
import validUrl from "../tools/validUrl";
import uaParser from 'ua-parser-js';
import { isInstagramContent, isInstagramContext, isInstagramPage, isProfileQuery } from '../tools/instagramLinks';

export default {
    props: ['inputPlaceholder', 'startButton', 'linkErrorText'],
    data() {
        return {
            input: null,
            previousInput: null,
            hls: false,
            processing: false,
            isInstagram: false,
            linkError: false,
        }
    },
    mounted() {
        this.isInstagram = window?.location.pathname?.includes('instagram') || window?.location?.href.includes('instagram')
        if (localStorage.getItem("search")) {
            this.input = localStorage.getItem("search");
            this.isInstagram ||= this.input[0] === '@'
            localStorage.removeItem("search");
            setTimeout(() => {
                this.change();
                this.submit();
            }, 100);
        }
        this.$root.$on('link-cast', (link) => {
            this.input = link;
            this.submit();
        });

        this.$root.$on('result-end', () => {
            this.processing = false;
        });

        const agent = new uaParser();
        const device = agent.getDevice();
        if (device.type === 'mobile' && window.innerHeight > 400) {
            const input = document.getElementById("id_url");
            input.blur();
            input.addEventListener("focus", () => {
                const iframe = document.querySelector("html > iframe");
                if (iframe) {
                    iframe.style.display = "none";
                }
            })
            input.addEventListener("click", () => {
                const iframe = document.querySelector("html > iframe");
                if (iframe) {
                    iframe.style.display = "none";
                }

            })
            input.addEventListener("blur", () => {
                const iframe = document.querySelector("html > iframe");
                if (iframe) {
                    iframe.style.display = "block";
                }
            })
        }
        const pathname = document.location.pathname;

    },
    methods: {
        enterClick(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                this.submit();
            }
        },

        submit() {
            if (this.hls) {
                return;
            }
            if (typeof this.input !== 'string') {
                return
            }
            this.input = this.input.trim()

            if (this.input === '') {
                return
            }
            this.handleSubmit(this.input)
        },
        change() {
            const input = this.input.trim();
            this.handleSubmit(input)
        },
        onInput(event) {
            const input = this.input.trim()
            this.isInstagram = isInstagramContext(input)
            this.linkError = false

            if (
                event.inputType === 'insertFromPaste' ||
                event.inputType === 'insertFromDrop' ||
                event.inputType === 'insertFromYank'
            ) {
                this.handleSubmit(input)
            }
        },
        handleSubmit(input){
            // Точка входа в запрос. Поле принимает ссылку на видео/пост, ссылку на профиль
            // инстаграма или ник (@username); произвольный текстовый запрос не поддерживается.
            input = input.trim()
            const target = this.resolveInput(input)

            if(this.previousInput === input) {
                // Повторная отправка того же значения: запрос не дублируем, но состояние ошибки
                // переустанавливаем — иначе после сброса linkError в onInput форма молчит на Enter.
                this.linkError = target === null
                return
            }
            this.previousInput = input
            this.linkError = false
            this.$root.$emit('clear-results')

            if(target === null) {
                // не-ссылка и не ник: просим вставить ссылку
                this.linkError = true
                return
            }
            this.$root.$emit(target.event, target.value)
        },
        resolveInput(input) {
            // Маршрутизация идёт по самому вводу, а не по контексту страницы: иначе на
            // /instagram-* страницах isInstagramPage() перехватывал бы и ютуб-ссылки.
            if(isInstagramContent(input)) {
                // ссылка на конкретный контент в инстаграмме (пост, reels, stories)
                return { event: 'link-submit', value: input }
            }
            if(isProfileQuery(input)) {
                // профиль инстаграма или ник (@username / instagram.com/username) — просмотр профиля.
                // Проверяем ДО validUrl: instagram.com/username проходит validUrl, но должен идти в профиль, а не в скачивание.
                return { event: 'profile-request', value: input }
            }
            if(isInstagramPage() && !/[:/]/.test(input)) {
                // На инстаграм-страницах голый токен без схемы и пути — это ник профиля.
                // Проверяем ДО normalizeUrl: ники допускают точку (john.doe), и иначе
                // такой ник был бы принят за ссылку на домен.
                return { event: 'profile-request', value: input }
            }
            const url = this.normalizeUrl(input)
            if(url !== null) {
                // ютуб или другая поддерживаемая ссылка
                return { event: 'link-submit', value: url }
            }
            return null
        },
        normalizeUrl(input) {
            // validUrl требует схему, поэтому youtube.com/watch?v=X и youtu.be/X без протокола
            // не проходят проверку. Подставляем https:// прежде чем признать ввод не-ссылкой.
            if(validUrl(input)) return input
            if(/^[\w-]+(?:\.[\w-]+)*\.[a-z]{2,}(?:[/?#:]|$)/i.test(input)) {
                const withScheme = `https://${input}`
                if(validUrl(withScheme)) return withScheme
            }
            return null
        },
    }
}
</script>

../tools/instagramLinks
